import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Skeleton } from "antd";
import "./Details.css";
import HTTP from "../../services/httpService";
import { formatDate, downloadCSV, getUserRole } from "../../services/util";
import { useParams, useNavigate } from "react-router-dom";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { DashboardGrids } from "../Home/Home";

function Details() {
    const { type } = useParams();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels, selectedHotelType, kioskSelection } =
        useContext(SettingContext);

    const [hotelData, setHotelData] = useState([]);
    const navigate = useNavigate();
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: type,
    });

    const [formData, setFormData] = useState({
        data_for: type,
        hotel_ids: hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        hotel_type: selectedHotelType,
        ...(selectedHotelType == "kiosk"
            ? { calling_hotel_type: kioskSelection }
            : {}),
        staff_id,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            fixed: "left",
            render: (text, record) => (
                <span
                    onClick={() =>
                        record["calls_count"]
                            ? getHotelData(record.hotel_id)
                            : {}
                    }
                    id={record.hotel_id}
                    style={{
                        color: record["calls_count"] ? "#1890ff" : "black",
                    }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Total Reservations",
            dataIndex: "checkin_count",
            key: "checkin_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "checkin_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "CheckIns",
            dataIndex: "total_checkin_new",
            key: "total_checkin_new",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "total_checkin_new"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "WalkIns",
            dataIndex: "walkin_count",
            key: "walkin_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "walkin_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Scan",
            dataIndex: "scan_count",
            key: "scan_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "scan_count" ? sortedInfo.order : null,
        },
        {
            title: "Cash Collected ($)",
            dataIndex: "cash_collected",
            key: "cash_collected",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "cash_collected"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Cash Collected Transaction",
            dataIndex: "cash_collected_trans",
            key: "cash_collected_trans",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "cash_collected_trans"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Cash Dispensed ($)",
            dataIndex: "cash_dispence",
            key: "cash_dispence",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "cash_dispence"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Cash Dispensed Transaction",
            dataIndex: "cash_dispenced_trans",
            key: "cash_dispenced_trans",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "cash_dispenced_trans"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Key Dispensed",
            dataIndex: "keys_count",
            key: "keys_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "keys_count" ? sortedInfo.order : null,
        },
        {
            title: "Calls",
            dataIndex: "calls_count",
            key: "calls_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "calls_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Transactions",
            dataIndex: "transaction_count",
            key: "transaction_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "transaction_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Cash ($)",
            dataIndex: "total_cash",
            key: "total_cash",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "total_cash" ? sortedInfo.order : null,
        },
        {
            title: "Housekeeping Tickets",
            dataIndex: "hk_ticket_count",
            key: "hk_ticket_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hk_ticket_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Housekeeping Orders",
            dataIndex: "hk_order_count",
            key: "hk_order_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hk_order_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Maintenance Tickets",
            dataIndex: "mnt_ticket_count",
            key: "mnt_ticket_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "mnt_ticket_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Dining Orders",
            dataIndex: "dinning_order_count",
            key: "dinning_order_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "dinning_order_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "CheckOuts",
            dataIndex: "checkout_keys_count",
            key: "checkout_keys_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "checkout_keys_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Enrolled Count",
            dataIndex: "enrolled_count",
            key: "enrolled_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "enrolled_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Self Check-In Count",
            dataIndex: "self_checkin_count",
            key: "self_checkin_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "self_checkin_count"
                    ? sortedInfo.order
                    : null,
        },
    ];

    function getHotelData(hotel_id) {
        navigate(`/calls/${hotel_id}`);
    }

    const {
        status: detailStatus,
        data: detailRes,
        refetch: fetchDetails,
    } = useQuery(
        type,
        async () => {
            return await HTTP("/dashboard/getDashboardData", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchDetails();
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            hotel_type: selectedHotelType,
            ...(selectedHotelType == "kiosk"
                ? { calling_hotel_type: kioskSelection }
                : {}),
            hotel_ids: [],
            all_selected: true,
            page: 0,
        });
        setCurrentPage(1);
    }, [selectedHotelType]);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        fetchDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (detailStatus === "success") {
            const { data, total } = detailRes;
            setHotelData(data);
            setTotalRecords(total);
        }
    }, [detailStatus, detailRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        console.log(order);
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
        setCurrentPage(current);
    }

    async function downloadReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getDashboardDataReport", {
            ...tempFormData,
        });
        const field = DashboardGrids.find(({ key }) => key == type);
        downloadCSV(res, `${field.title}_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downloadReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {!hotelData.length ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns.filter(
                            ({ key }) => key === type || key === "hotel_name",
                        )}
                        tableData={hotelData}
                        currentPage={currentPage}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </Card>
    );
}

export { Details };
